export default "__VITE_ASSET__BtPtD7M4__"